'use client'

import * as AriakitMenu from '@ariakit/react/menu'
import * as styles from './Menu.css'

export function MenuSeparator() {
  return <AriakitMenu.MenuSeparator className={styles.separator} />
}
